import {AbstractControl, FormArray as fm} from "@angular/forms";

export class FormArray<T extends AbstractControl<any, any>> extends fm<T> {

    *[Symbol.iterator](): IterableIterator<T> {
        for (const control of this.controls) {
            yield control as T;
        }
    }

}